import { Button, HStack, Text, chakra, forwardRef, useRadio, useRadioGroup } from '@chakra-ui/react';
import React from 'react';
import { omit, pick } from 'ramda';
const SwitchOption = forwardRef((props, ref)=>{
    const { displayValue , ...useRadioProps } = props;
    const { state , getInputProps , getCheckboxProps , htmlProps , getLabelProps  } = useRadio(useRadioProps);
    return /*#__PURE__*/ React.createElement(chakra.label, {
        ...htmlProps,
        cursor: "pointer"
    }, /*#__PURE__*/ React.createElement("input", getInputProps({
        ref
    })), /*#__PURE__*/ React.createElement(Button, {
        as: "div",
        ...getCheckboxProps(),
        bg: state.isChecked ? 'fill.interactive' : 'transparent',
        color: state.isChecked ? 'text.inverse' : 'text.primary',
        px: 3,
        py: 1,
        rounded: "full",
        textAlign: "center",
        variant: "switch",
        w: "full"
    }, /*#__PURE__*/ React.createElement(Text, {
        textStyle: "lBold",
        ...getLabelProps()
    }, displayValue)));
});
const radioGroupPropNames = [
    'value',
    'defaultValue',
    'onChange',
    'isDisabled',
    'isFocusable',
    'name',
    'isNative'
];
export const ContentSwitch = forwardRef((props, ref)=>{
    const { options , ...rest } = props;
    const radioGroupProps = pick(radioGroupPropNames, rest);
    const flexProps = omit(radioGroupPropNames, rest);
    const { getRadioProps , getRootProps , isDisabled  } = useRadioGroup(radioGroupProps);
    return /*#__PURE__*/ React.createElement(HStack, {
        ...getRootProps(),
        borderColor: "stroke.light",
        borderRadius: "full",
        borderWidth: "1px",
        p: "6px" // This padding is not standard, but makes sense given the type of component
        ,
        ref: ref,
        w: "full",
        ...flexProps
    }, options.map((option)=>/*#__PURE__*/ React.createElement(SwitchOption, {
            displayValue: option.text,
            isDisabled: isDisabled,
            key: option.key,
            w: "full",
            ...getRadioProps({
                value: option.key
            })
        })));
});

//# sourceMappingURL=content-switch.js.map